import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'avatar',
  standalone: true,
})
export class AvatarPipe implements PipeTransform {
  transform(
    firstName: string,
    lastName: string,
    options?: {
      background?: string;
      color?: string;
      size?: number;
      bold?: boolean;
    }
  ): string {
    const background = options?.background || '007E33';
    const color = options?.color || 'fff';
    const size = options?.size || 128;
    const bold = options?.bold ? 'false' : 'true';
    return `https://ui-avatars.com/api/?name=${firstName}+${lastName}&background=${background}&color=${color}&size=${size}&bold=${bold}`;
  }
}
